import React from 'react';
import { CustomSettingKey } from '../../../Base/Enums/CustomSettingKey.enum';
import { CustomSettingsItemScheme } from '../../../CustomSettings/Components/CustomSettingsItem';
import { CustomSettingsItemType } from '../../../CustomSettings/Enums/CustomSettingsItemType.enum';
import CustomSettings from '../../../CustomSettings/Components/CustomSettings';

interface Props {
	customSettingKey: CustomSettingKey;
	onSave: () => void;
}

const MONITORING_CENTER_FIELDS: Omit<CustomSettingsItemScheme, 'type'>[] = [
	{
		key: 'number',
		label: 'component.monitoringCenterSettings.number',
	},
	{
		key: 'priority',
		label: 'component.monitoringCenterSettings.priority',
	},
	{
		key: 'state',
		label: 'component.monitoringCenterSettings.state',
	},
	{
		key: 'requestType',
		label: 'component.monitoringCenterSettings.requestType',
	},
	{
		key: 'patient',
		label: 'component.monitoringCenterSettings.patient',
	},
	{
		key: 'birthNumber',
		label: 'component.monitoringCenterSettings.birthNumber',
	},
	{
		key: 'attendingDoctor',
		label: 'component.monitoringCenterSettings.attendingDoctor',
	},
	{
		key: 'assignment',
		label: 'component.monitoringCenterSettings.assignment',
	},
	{
		key: 'workplace',
		label: 'component.monitoringCenterSettings.workplace',
	},
	{
		key: 'diagnosis',
		label: 'component.monitoringCenterSettings.diagnosis',
	},
	{
		key: 'noteForMedics',
		label: 'component.monitoringCenterSettings.noteForMedics',
	},
	{
		key: 'created',
		label: 'component.monitoringCenterSettings.created',
	},
	{
		key: 'lastEdit',
		label: 'component.monitoringCenterSettings.lastEdit',
	},
];

const SOLVED_MONITORING_CENTER_FIELDS: Omit<
	CustomSettingsItemScheme,
	'type'
>[] = [
	{
		key: 'number',
		label: 'component.monitoringCenterSettings.number',
	},
	{
		key: 'requestType',
		label: 'component.monitoringCenterSettings.requestType',
	},
	{
		key: 'patient',
		label: 'component.monitoringCenterSettings.patient',
	},
	{
		key: 'birthNumber',
		label: 'component.monitoringCenterSettings.birthNumber',
	},
	{
		key: 'attendingDoctor',
		label: 'component.monitoringCenterSettings.attendingDoctor',
	},
	{
		key: 'closedBy',
		label: 'component.monitoringCenterSettings.closedBy',
	},
	{
		key: 'workplace',
		label: 'component.monitoringCenterSettings.workplace',
	},
	{
		key: 'diagnosis',
		label: 'component.monitoringCenterSettings.diagnosis',
	},
	{
		key: 'closedWith',
		label: 'component.monitoringCenterSettings.closedWith',
	},
	{
		key: 'created',
		label: 'component.monitoringCenterSettings.created',
	},
	{
		key: 'closed',
		label: 'component.monitoringCenterSettings.closed',
	},
];

const addTypeToFields = (
	type: CustomSettingsItemType,
	fields: Omit<CustomSettingsItemScheme, 'type'>[],
): CustomSettingsItemScheme[] => {
	return fields.map(item => {
		return {
			...item,
			type,
		};
	});
};

const FIELDS: Partial<Record<CustomSettingKey, CustomSettingsItemScheme[]>> = {
	[CustomSettingKey.MONITORING_CENTER_ALL_REQUESTS]: addTypeToFields(
		CustomSettingsItemType.YES_NO_FIELD,
		MONITORING_CENTER_FIELDS,
	),
	[CustomSettingKey.MONITORING_CENTER_NEW_REQUESTS]: addTypeToFields(
		CustomSettingsItemType.YES_NO_FIELD,
		MONITORING_CENTER_FIELDS,
	),
	[CustomSettingKey.MONITORING_CENTER_SOLVED_REQUESTS]: addTypeToFields(
		CustomSettingsItemType.YES_NO_FIELD,
		SOLVED_MONITORING_CENTER_FIELDS,
	),
};

const MonitoringCenterSettings: React.FC<Props> = ({
	customSettingKey,
	onSave,
}) => {
	const items = FIELDS[customSettingKey];

	if (items) {
		return (
			<CustomSettings
				storageKey={customSettingKey}
				items={items}
				onSave={onSave}
			/>
		);
	}

	return <></>;
};

export default MonitoringCenterSettings;
